/* eslint-disable no-param-reassign */
import isEmpty from "lodash/isEmpty";
import { ACTION_TYPES } from "../constants";
import { getXrModefromURL } from "./MachineUtils";

const executeArrayOfFunctions = (functionArray) => {
  return () => {
    functionArray.map((fn) => fn());
  };
};
export const replaceWithCallback = (
  actions,
  clickObject,
  modelId,
  eventAction,
  eventLabel,
  appMode,
  nonInteraction
) => {
  const replacedButtonConfig = [];
  console.log("clickobject vibhor", eventAction, clickObject);
  if (!isEmpty(clickObject))
    clickObject.forEach((action) => {
      console.log("clickobject foreach", action);
      if (
        action.type === ACTION_TYPES.MATERIALS ||
        action.type === ACTION_TYPES.OPACITY
      ) {
        Object.keys(action?.config || {}).forEach((materialName) => {
          replacedButtonConfig.push(() => {
            actions.ARModels.applyMaterial(
              modelId,
              materialName,
              action.config[materialName],
              actions.AssetLoader.getAsset
            );
          });
        });
      }
      if (action.type === ACTION_TYPES.DYNAMIC_ANIMATION) {
        console.log(
          "inside dynamicanimation",
          modelId,
          action.config,
          eventAction
        );
        replacedButtonConfig.push(() => {
          actions.ARModels.playDynamicAnimation(modelId, action.config);
        });
      }
      if (action.type === ACTION_TYPES.CLIP_ANIMATION) {
        console.log(
          "inside clipAnimation",
          modelId,
          action.config,
          eventAction
        );
        let clampFinishFlag = true;
        if (action.config && "clampFinishFlag" in action.config) {
          clampFinishFlag = action.config.clampFinishFlag;
        }
        // const clampFinishFlag = eventAction !== "onLoad";
        replacedButtonConfig.push(() => {
          actions.ARModels.playClipAnimation(
            modelId,
            action.config,
            clampFinishFlag
          );
        });
      }
    });
  console.log("replacewithcallback", replacedButtonConfig, clickObject);
  if (appMode !== "ENGINE") {
    const mode = getXrModefromURL(actions.window);
    replacedButtonConfig.push(() => {
      actions.Tracker.sendAnalyticsEvent(
        mode,
        {
          action: eventAction,
        },
        { nonInteraction },
        {
          mode,
          referrer: eventLabel,
        }
      );
    });
    // replacedButtonConfig.push(() => {
    //   actions.Tracker.sendToGa("", "", eventAction, eventLabel, nonInteraction);
    // });
  }
  return executeArrayOfFunctions(replacedButtonConfig);
};

export const generateUIConfig = (
  modelId,
  actions,
  skuConfig,
  mode,
  platform,
  appMode
) => {
  // pepperfry specific code
  console.log("dd", skuConfig);
  const replacedConfig = JSON.parse(JSON.stringify(skuConfig?.uiConfig));
  console.log("generating uiconfigXXX", replacedConfig);
  if (replacedConfig.menu)
    replacedConfig.menu.forEach((menuItem) => {
      menuItem.onClick = replaceWithCallback(
        actions,
        menuItem.onClick,
        modelId,
        "onClick Button",
        `Button - ${menuItem.name}`,
        appMode,
        false
      );
      menuItem.onUnClick = replaceWithCallback(
        actions,
        menuItem.onUnClick,
        modelId,
        "onUnClick Button",
        `Button - ${menuItem.name}`,
        appMode,
        false
      );
      if (menuItem.menu.length > 0) {
        menuItem.menu.forEach((submenuItem) => {
          submenuItem.onClick = replaceWithCallback(
            actions,
            submenuItem.onClick,
            modelId,
            "Submenu onClick Button",
            `Button - ${submenuItem.name}`,
            appMode,
            false
          );
          submenuItem.onUnClick = replaceWithCallback(
            actions,
            submenuItem.onUnClick,
            modelId,
            "Submenu onUnClick Button",
            `Button - ${submenuItem.name}`,
            appMode,
            false
          );
        });
      }
    });
  if (replacedConfig.onLoad) {
    replacedConfig.onLoad = replaceWithCallback(
      actions,
      replacedConfig.onLoad[mode][platform],
      modelId,
      "onLoad",
      "",
      appMode,
      true
    );
  }

  console.log("generateUIConfig", replacedConfig);
  return replacedConfig;
};

// eslint-disable-next-line no-unused-vars
export function buildGraph(object) {
  const data = { nodes: {}, materials: {} };
  if (object) {
    object.traverse((obj) => {
      if (obj.name) {
        data.nodes[obj.name] = obj;
      }
      if (obj.material && !data.materials[obj.material.name]) {
        data.materials[obj.material.name] = obj.material;
      }
    });
  }
  return data;
}
